import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { canonicalizeLegacyRouterUrl } from '../routing/canonicalize-legacy-url';

/** Single redirect point for legacy Pelican Account URLs (see full-launch checklist). */
export const legacyUrlCanonicalizerGuard: CanActivateFn = (_route, state) => {
  const canonical = canonicalizeLegacyRouterUrl(state.url);
  if (canonical === null) {
    return true;
  }

  const router = inject(Router);
  return router.parseUrl(canonical);
};
